// Exports
export default {
	"TumblerStretch": "TumblerStretch_TjZLe"
};
